var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrutedLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1381",
    "data-name": "Grupo 1381",
    transform: "translate(-309 -2851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1378",
    "data-name": "Grupo 1378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1372",
    "data-name": "Grupo 1372",
    transform: "translate(0.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_971",
    "data-name": "Caminho 971",
    d: "M0,0H27V27H0Z",
    transform: "translate(308.542 2851)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_972",
    "data-name": "Caminho 972",
    d: "M12.875,2A7.884,7.884,0,0,1,20.75,9.875c0,5.906-7.875,14.625-7.875,14.625S5,15.781,5,9.875A7.884,7.884,0,0,1,12.875,2ZM11.154,15.5,18.5,8.086,16.925,6.5l-5.771,5.828L8.825,9.976,7.25,11.563Z",
    transform: "translate(309.168 2851.25)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrutedLocations);
export default __webpack_public_path__ + "static/media/truted-locations.850784206e1078e649f0bf7e1102f97d.svg";
export { ForwardRef as ReactComponent };